export default function Footer() {
  return <footer className="bg-stone-800 text-stone-300 py-6 md:py-8 mt-10 md:mt-16">
    <div className="max-w-7xl mx-auto px-4 text-center">
      <p className="mb-2 text-sm md:text-base">© 2026 PlanetGachi 가치표 사이트. All rights reserved.</p>
      <p className="text-xs md:text-sm">Powered by antiYoon_</p>
    </div>
  </footer>;
}
